<template>
  <v-app-bar app dense style="
      background: linear-gradient(50.5deg, #ffffffff 27.9%, #ffffffff 84.2%);
    ">
    <v-app-bar-nav-icon color="#45009FFF" v-if="isMobileView" @click="drawer = !drawer"></v-app-bar-nav-icon>

    <v-toolbar-title>
      <v-img :src="require('@/assets/workforce_logo.png')" max-width="100"></v-img>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn :to="{ name: 'faceRecognition' }" variant="text" rounded color="#45009FFF" class="mx-3" v-if="isMobileView">
      <v-icon>mdi-face-recognition</v-icon>
    </v-btn>

    <template v-if="!isMobileView">
      <v-toolbar-items>
        <v-btn v-for="(item, index) in toolbarItems" :key="index" :to="{ name: item.to }" :prepend-icon="item.icon"
          stacked variant="text" size="small" color="#45009FFF">
          {{ item.name }}
        </v-btn>
      </v-toolbar-items>

      <v-divider class="border-opacity-25" vertical></v-divider>

      <div v-if="!authenticated" class="d-flex ga-2 mx-3">
        <v-btn :to="{ name: 'login' }" variant="outlined" rounded color="#45009FFF">
          Login
        </v-btn>
        <v-btn :to="{ name: 'register' }" variant="text" rounded color="#45009FFF">
          Register
        </v-btn>
      </div>

      <v-menu width="256" rounded v-else>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props" class="mx-3">
            <v-avatar color="#45009FFF">
              <span>{{ initial }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <!-- User Info -->
            <v-list-item class="d-flex align-center">
              <template v-slot:prepend>
                <v-avatar color="#45009FFF" size="large" class="my-2">
                  <span class="text-h5">{{ initial }}</span>
                </v-avatar>
              </template>
              <div>
                <v-list-item-title>{{ fullName }}</v-list-item-title>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </div>
            </v-list-item>

            <!-- View Profile -->
            <v-list-item :to="{ name: 'profile' }" color="primary">
              <template v-slot:prepend>
                <v-icon icon="mdi-face-man-profile"></v-icon>
              </template>
              <v-list-item-title>View Profile</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <!-- Job Applications -->
            <!-- <v-list-item :to="{ name: 'jobApplications' }" color="primary">
              <template v-slot:prepend>
                <v-icon icon="mdi-briefcase-account-outline"></v-icon>
              </template>
              <v-list-item-title>Job Applications</v-list-item-title>
            </v-list-item> -->
            <!-- Employee Menu Items -->
            <template v-if="isEmployee">
              <v-list-item :class="item?.isHidden ? 'd-none' : ''" v-for="(item, i) in menuItems" :key="i"
                :to="{ name: item.to }" color="primary">
                <template v-slot:prepend>
                  <v-icon :icon="item.icon"></v-icon>
                </template>
                <v-list-item-title> {{ item.title }} </v-list-item-title>
              </v-list-item>
            </template>

            <v-divider></v-divider>

            <!-- Logout -->
            <v-list-item class="account-link text-red-darken-1 mt-1" @click="handleLogout">
              <template v-slot:prepend>
                <v-icon icon="mdi-logout-variant"></v-icon>
              </template>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>

      <v-divider class="border-opacity-25" vertical></v-divider>

      <div class="px-2">
        <v-btn :to="{ name: 'faceRecognition' }" variant="text" rounded color="#45009FFF">
          <v-icon>mdi-face-recognition</v-icon>
        </v-btn>
      </div>

      <v-tooltip text="Switch Portal" location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" icon :to="{ name: 'dashboard' }" v-if="canSwitchPortal">
            <v-icon color="#45009FFF">mdi-swap-horizontal</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </template>
  </v-app-bar>

  <!-- Mobile Drawer -->
  <v-navigation-drawer v-model="drawer" app temporary>
    <v-list>
      <v-list-item v-for="(item, index) in toolbarItems" :key="index" :to="{ name: item.to }">
        <!-- <v-icon left>{{ item.icon }}</v-icon> -->
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list v-if="authenticated">
      <v-list-item :to="{ name: 'profile' }">
        <!-- <v-icon left>mdi-account</v-icon> -->
        <v-list-item-title> View Profile </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="isEmployee" v-for="(item, i) in menuItems" :key="i" :to="{ name: item.to }">
        <!-- <v-icon left>{{ item.icon }}</v-icon> -->
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="canSwitchPortal" :to="{ name: 'dashboard' }">
        <!-- <v-icon left>mdi-swap-horizontal</v-icon> -->
        <v-list-item-title> Switch Portal </v-list-item-title>
      </v-list-item>

      <v-list-item class="text-red-darken-1" @click="handleLogout">
        <!-- <v-icon left>mdi-logout-variant</v-icon> -->
        <v-list-item-title> Logout </v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list v-else>
      <v-list-item :to="{ name: 'login' }">
        <!-- <v-icon left>mdi-login</v-icon> -->
        <v-list-item-title> Login </v-list-item-title>
      </v-list-item>
      <v-list-item :to="{ name: 'register' }">
        <!-- <v-icon left>mdi-account-plus</v-icon> -->
        <v-list-item-title> Register </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

  <LogoutDialog ref="logout" />
</template>

<script>
import { hasRole } from "@/helpers/auth"
import { useDisplay } from "vuetify"
import { mapActions, mapGetters } from "vuex"
import LogoutDialog from "@/components/LogoutDialog"

export default {
  components: { LogoutDialog },

  data: () => ({
    drawer: false,
    display: useDisplay(),
    toolbarItems: [
      { name: "Jobs", to: "jobs", icon: "mdi-briefcase-variant" },
      // { name: 'About Us', to: 'aboutUs', icon: 'mdi-information' },
      { name: "FAQ", to: "faq", icon: "mdi-frequently-asked-questions" },
      { name: "Contact", to: "contact", icon: "mdi-phone" },
    ],
  }),

  computed: {
    ...mapGetters("auth", [
      "authenticated",
      "user",
      "userRoles",
      "userHeadDepartments",
    ]),

    isMobileView() {
      return this.display.smAndDown
    },

    canSwitchPortal() {
      return hasRole(this.userRoles, ["Super Admin", "Admin", "Audit", "Accounting", "IT", "TimeKeeper", "FieldKeeper", "Project Engineer", "Project Manager", "Construction Head", "Audit Viewer", "Accounting Viewer"])
    },

    isSuperAdmin() {
      return hasRole(this.userRoles, "Super Admin")
    },

    isHead() {
      return this.userHeadDepartments.length > 0
    },

    isHeadOrAdmin() {
      return this.userHeadDepartments.length > 0 || this.isSuperAdmin
    },

    isEmployee() {
      return hasRole(this.userRoles, ["Admin", "Employee"])
    },

    initial() {
      return this.user?.first_name?.charAt(0) || this.user?.email?.charAt(0)
    },

    fullName() {
      return this.user ? `${this.user.first_name} ${this.user.last_name}` : ""
    },

    menuItems() {
      return [
        // { title: "Attendance", to: "attendance", icon: "mdi-clock" },
        { title: "Account", to: "account", icon: "mdi-account-box" },
        {
          title: "Attendance",
          to: "DepartmentAttendance",
          icon: "mdi-account-group",
          isHidden: !this.isHead,
        },
        // { title: "Files", to: "myDocs", icon: "mdi-file-multiple" },
        // { title: "Leaves", to: "myLeaves", icon: "mdi-file-document" },
        // { title: "Overtime", to: "myOvertime", icon: "mdi-clock" },
        // { title: "OB", to: "myOfficialBusiness", icon: "mdi-calendar" },
        {
          title: "Request Salary",
          to: "RequestSalary",
          icon: "mdi-cash",
          isHidden: !this.isHeadOrAdmin,
        },
        // { title: "Payroll", to: "myPayroll", icon: "mdi-credit-card" },
        // { title: "Loan", to: "myLoan", icon: "mdi-cash" },
        // {
        //   title: "Approval Forms",
        //   to: "approvalForms",
        //   icon: "mdi-tag-check",
        //   isHidden: !this.isHeadOrAdmin,
        // },
      ]
    },
  },

  methods: {
    ...mapActions("auth", ["logout"]),

    async handleLogout() {
      this.$refs.logout.show()
      await this.logout()
      this.$router.push({ name: "jobs" })
      this.$refs.logout.hide()
    },
  },
}
</script>

<style scoped>
.menu-card {
  font-family: "Poppins", sans-serif !important;
}

.account-link:hover {
  cursor: pointer;
  background-color: #f5f5f5;
}
</style>
